import { makeStyles, Theme } from '@material-ui/core';
import '../../styles/fonts.css';
import Colors from '../Colors';

export const useStyle = makeStyles((theme: Theme) => ({

  logo: {
    width: 40,
    marginRight: '2%',
  },
  govLogo: {
    width: 140,
    [theme.breakpoints.down('xs')]: {
      width: '150px',
    },
  },
  appBar: {
    backgroundColor: Colors.main,
    zIndex: 10,
    display: 'flex',
    justifyItems: 'center',
    padding: '0.5% 0 0.5% 0',
  },
  appBarGrid: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  appBarGrid2: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },

  boxButton: {
    display: 'flex',
    justifySelf: 'end',
    width: 600,
    height: '100%',
    justifyContent: 'space-around',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginRight: '10%',
    },
  },
  typo: {
    display: 'none',
    margin: '5px',
    fontSize: '18px',
    textAlign: 'center',
    color: Colors.secundary,
    fontWeight: 'bolder',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  menuButton: {
    borderRadius: 0,
    padding: '15px',
    zIndex: 20,
    display: 'none',
    '&:hover': {
      backgroundColor: '#ff0000',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  button1: {
    fontFamily: 'Roboto',
    textDecoration: 'none',
    color: '#404040',
    padding: '5px',
    fontSize: '24px',
    height: '100%',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.2)',
    },
  },
  button2: {
    textDecoration: 'none',
    fontFamily: "Texta Medium",
    letterSpacing: "1px",
    color: Colors.white,
    padding: '7px',
    paddingRight: '20px',
    paddingLeft: '20px',
    marginLeft: '15px',
    textTransform: 'capitalize',
    fontWeight: 'normal',
    '&:hover': {
      backgroundColor: Colors.white,
      fontFamily: "Texta Heavy",
      color: Colors.main,
    },
    fontSize: '18px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  buttonInverted: {
    textDecoration: 'none',
    fontFamily: "Texta Medium",
    letterSpacing: "1px",
    color: Colors.white,
    padding: '7px',
    paddingRight: '20px',
    paddingLeft: '20px',
    marginLeft: '15px',
    textTransform: 'capitalize',
    fontWeight: 'normal',
    border: `1px solid ${Colors.white}`,
    backgroundColor: Colors.main,
    '&:hover': {
      backgroundColor: Colors.hoverWhite,
      border: `1px solid ${Colors.hoverWhite}`,
      fontFamily: "Texta Heavy",
      color: Colors.main,
    },
    fontSize: '16px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  active: {
    textDecoration: 'none',
    fontFamily: "Texta Heavy",
    letterSpacing: "1px",
    padding: '7px',
    paddingRight: '20px',
    paddingLeft: '20px',
    marginLeft: '15px',
    textTransform: 'capitalize',
    fontWeight: 'normal',
    color: Colors.main,
    backgroundColor: Colors.white,
    fontSize: '18px',
    '&:hover': {
      backgroundColor: Colors.hoverWhite,
      color: Colors.main,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  button3: {
    fontFamily: 'Roboto',
    textDecoration: 'none',
    color: '#404040',
    padding: '5px',
    fontSize: '24px',
    height: '100%',
    justifySelf: 'center',
    alignSelf: 'center',
  },
  button4: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    textDecoration: 'none',
    fontFamily: "Texta Medium",
    color: '#ffffff',
    padding: '7px',
    paddingRight: '20px',
    paddingLeft: '20px',
    marginLeft: '15px',
    cursor: 'pointer',
    fontWeight: 'normal',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#ffffff',
      fontFamily: "Texta Heavy",
      color: Colors.main,
    },
    fontSize: '18px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  button5: {
    textDecoration: 'none',
    fontFamily: 'Roboto',
    color: '#404040',
    padding: '5px',
    marginLeft: '15px',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.2)',
    },
    fontSize: '18px',
  },
  menuAccount: {
    margin: '2% 0 0 -1%',
    borderRadius: '0px',
    '& a': {
      color: '#000',
      textDecoration: 'none',
    },
  },
  menuItemAccount: {
    borderTop: '0.5px solid rgba(0, 0, 0, 0.5)',
    fontFamily: 'Texta Medium',
    letterSpacing: '1px',
    color: '#000',
    '&:first-child': {
      border: 'none',
    },
    '&:hover': {
      backgroundColor: Colors.main,
      fontFamily: 'Texta Heavy',
      color: '#ffffff',
    },
  },
  menuRegisters: {
    marginTop: '2%',
    width: '200px',
    borderRadius: '0px',
    '& a': {
      color: '#000',
      textDecoration: 'none',
      fontFamily: 'Texta Medium',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '18px',
    },
  },
  menuItemMap: {
    marginBottom: '5%',
    fontFamily: 'Texta Medium',
    letterSpacing: '1px',
    '&:hover': {
      backgroundColor: Colors.main,
      color: '#ffffff',
    }
  },
}));
const drawerWidth = 240;
export const drawerStyles = makeStyles((theme) => ({
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  button1: {
    textDecoration: 'none',
    color: '#404040',
    margin: '5px',
    fontSize: '18px',
    width: '100%',
    fontFamily: 'Roboto',
    display: 'block',
  },
  button2: {
    textDecoration: 'none',
    margin: '5px 5px 5px 13px',
    color: '#404040',
    fontFamily: 'Roboto',
    fontSize: '16px',
    display: 'block',
    width: '100%',
  },
  button3: {
    textDecoration: 'none',
    color: '#404040',
    margin: '5px',
    fontSize: '18px',
    fontFamily: 'Roboto',
    display: 'block',
  },
  responsive: {
    display: 'block',
    flexFlow: 'column',
    overflowX: 'hidden',
  },
}));
